













































































import Controls from './components/Controls.vue'
import HeadingBlock from './components/blocks/HeadingBlock.vue'
import SubheadingBlock from './components/blocks/SubheadingBlock.vue'
import TextBlock from './components/blocks/TextBlock.vue'
import ImageBlock from './components/blocks/ImageBlock.vue'
import VideoBlock from './components/blocks/VideoBlock.vue'
import TeaserBlock from './components/blocks/TeaserBlock.vue'
import GalleryBlock from './components/blocks/GalleryBlock.vue'
import GistBlock from './components/blocks/GistBlock.vue'
import TweetBlock from './components/blocks/TweetBlock.vue'

export default {
  name: 'bb8'

  data: -> {
    config: {}
    blockTypes: ['heading', 'subheading', 'text', 'image', 'video', 'teaser', 'gallery', 'gist', 'tweet']
    blocks: []
    ids: []
  }

  props: ['bb8InitialData', 'bb8Config']

  components: {
    Controls
    HeadingBlock
    SubheadingBlock
    TextBlock
    ImageBlock
    VideoBlock
    TeaserBlock
    GalleryBlock
    GistBlock
    TweetBlock
  }

  computed: {
    ids: ->
      this.blocks.map((b) -> b.id).sort()
    output: ->
      JSON.stringify(this.blocks)
  }

  created: ->
    this.config = JSON.parse(this.bb8Config)[0]
    this.blockTypes = this.config.blockTypes if this.config.blockTypes && this.config.blockTypes.length > 0
    blocks = JSON.parse(this.bb8InitialData)

    # The blocks list relies on its child component states
    # so we have to track the list by a unique id instead of the index
    # see `:key='block.id'` in the template
    block.id = blocks.indexOf(block) + 1 for block in blocks

    this.blocks = blocks

  methods: {
    generateBlockId: ->
      idsLength = this.ids.length
      if idsLength then this.ids[idsLength - 1] + 1 else 1

    addBlock: (newBlock) ->
      this.blocks.splice(newBlock.index + 1, 0, {
        blocktype: newBlock.blocktype
        id: this.generateBlockId()
        fields: {}
      })

    removeBlock: (index) ->
      this.blocks.splice(index, 1)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/Bb8.vue